"use strict";
// hyphen '‐' '\u2010'; | hyphen_minus '-' '\u002D'; | minus '−' '\u2212'; | dash '–' '\u2013';
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSettings = void 0;
var DefaultSettings;
(function (DefaultSettings) {
    DefaultSettings[DefaultSettings["MIN_LENGTH_PASSWORD"] = 6] = "MIN_LENGTH_PASSWORD";
    DefaultSettings[DefaultSettings["MIN_VALUE"] = 1] = "MIN_VALUE";
    DefaultSettings[DefaultSettings["MIN_LENGTH_POST_CODE"] = 4] = "MIN_LENGTH_POST_CODE";
    DefaultSettings["PATTERN_VAT"] = "BE0123.123.123";
    DefaultSettings["PATTERN_PHONE"] = "03/457.34.90";
    DefaultSettings["PATTERN_MOBILE_PHONE"] = "0499/12.42.15";
    DefaultSettings["STREET_NAME_REGEX"] = ".*[a-zA-Z]+.*";
    DefaultSettings["POSTAL_CODE_NL"] = "^([1-9]\\d{3})\\s{0,1}([A-Z]{2})$";
    DefaultSettings["POSTAL_CODE_BE"] = "^[1-9]{1}[0-9]{3}$";
    DefaultSettings["POSTAL_CODE_DE_FR"] = "^[0-9]{5}$";
    DefaultSettings["POSTAL_CODE_UK"] = "^[A-Z]{1,2}[0-9R][0-9A-Z]? [0-9][ABD-HJLNP-UW-Z]{2}$";
    DefaultSettings["HOUSE_NUMBER_NL"] = "^\\d{1,5}(\\s?[-\u2013]{1}\\s?\\d{1,5})?$";
    DefaultSettings["HOUSE_NUMBER_NL_ALPHA"] = "^[A-Z]{1}\\d{3}(\\s?[-\u2013]{1}\\s?\\d{3})?$";
    DefaultSettings[DefaultSettings["MAX_LENGTH_TEXT_AREA"] = 280] = "MAX_LENGTH_TEXT_AREA";
    DefaultSettings["STREET_BE_LU_REGEXP"] = "^[a-zA-Z\u00C0-\u0178'&.\\s-\u2013\u2010\u2212]+$";
    DefaultSettings["HOUSE_NUMBER_BE_LU_REGEXP"] = "^[a-zA-Z0-9-\u2013\u2010\u2212]+$";
    DefaultSettings["HOUSE_NUMBER_ADDITION_BE_LU_REGEXP"] = "^[a-zA-Z0-9]+$";
})(DefaultSettings || (exports.DefaultSettings = DefaultSettings = {}));
//# sourceMappingURL=DefaultSettingsEnum.js.map